export default __webpack_public_path__ + "static/media/lep-home.7d4b2d0c.png";